import React from 'react';
import { CandidateStatus } from '../enums/CandidateStatus';
import { FormattedMessage } from 'react-intl';

export const inactiveProgressMessage = (status: CandidateStatus) => {
  switch (status) {
    case CandidateStatus.InactiveHibernate:
      return (
        <FormattedMessage id="notHired" defaultMessage="Not hired" />
      );
    case CandidateStatus.InactiveHired:
      return (
        <FormattedMessage id="hired" defaultMessage="Hired" />
      );
    default:
      return undefined;
  }
};
